import React, { useState } from 'react';

import './Expenses.css';
import Card from '../UI/Card';
import ExpensesFilter from './ExpensesFilter';
import ExpensesList from './ExpensesList';
import ExpensesChart from './ExpensesChart';


const Expenses = (props) => {
  const [filteredYear, setFilteredYear] = useState('2020');    //use state is to set default value, it return latest updated variable and a function
                                                                // filteredYear me updated value hogi jaise 2019
  const filterChangeHandler = selectedYear => {                 //selected year me onChangeFilter ki value hogi
    setFilteredYear(selectedYear);                // ab setFilteredYear() iske upar declared h to ab upar jaege
  };
   const filteredExpenses=props.items.filter(expenses=>{  
            return (expenses.date.getFullYear().toString()===filteredYear);
   });





    return (<div>
    <Card className="expenses">
      
          <ExpensesFilter  selected={filteredYear} onChangeFilter={filterChangeHandler}></ExpensesFilter>
          <ExpensesChart expenses={filteredExpenses}></ExpensesChart>
             <ExpensesList items={filteredExpenses} />  
    </Card>                  
      </div> );         //line no 15 me child fn se aai hui year ki value receive ho jaegi and then vo value aage filterChangeHandler  vale fn me chali jaegi aur vha use hogi
};
export default Expenses;